import { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Tabs } from '../../../../../common/tabs'
import { getAppendStyleItemWithCustom } from '../../../../../common/tabs/helper'
import TextEllipsis from '../../../../../common/textEllipsis'
import { keyBy } from '../../../../../helpers/common'
import { valToPercent } from '../../../../../helpers/value'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  getYearTabs,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeYear, selectYear } from '../../store/slice'
import {
  selectDataViewByEachYear,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const WIDTH_ICON = 28

const widthContainers = {}

const EachYear = ({ id, isDynamicReport, year: yearSetting }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const year = useSelector(selectYear(id, yearSetting))
  const data = useSelector(selectDataViewByEachYear(year)) || []
  const indicatorById = useSelector(selectIndicatorById)
  const years = useSelector(selectYears)

  const tabs = getYearTabs(years)

  const mapData = [
    [
      {
        ...getValueAndTitleCheckbox(indicatorById, 'RT0059'),
        percent: 83,
        color: '#006AA6',
      },
      {
        ...getValueAndTitleCheckbox(indicatorById, 'RT0035'),
        percent: 17,
        color: '#006AA6',
      },
    ],
    [
      {
        ...getValueAndTitleCheckbox(indicatorById, 'RT0054'),
        percent: 80,
        color: '#FFCD60',
      },
      {
        ...getValueAndTitleCheckbox(indicatorById, 'RT0003'),
        percent: 20,
        color: '#FFCD60',
      },
    ],
    [
      {
        ...getValueAndTitleCheckbox(indicatorById, 'FA001'),
        percent: 33.33,
        color: '#C06C84',
      },
      {
        ...getValueAndTitleCheckbox(indicatorById, 'RT0065'),
        percent: 33.33,
        color: '#C06C84',
      },
      {
        ...getValueAndTitleCheckbox(indicatorById, 'RT0052'),
        percent: 33.33,
        color: '#C06C84',
      },
    ],
  ]

  useEffect(() => {
    if (
      (tabs.length && !year) ||
      !tabs.map((item) => item.key).includes(String(year))
    ) {
      setYear(tabs[tabs.length - 1]?.key)
    }
  }, [tabs.length, year])

  const setYear = (year) => dispatch(changeYear({ id, year }))

  const format = (id) =>
    valToPercent(dataById[id]?.value, locale, undefined, undefined, 0)

  const dataById = keyBy(data, 'id')

  const isNoData = !data.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className={classes.roaAndRoeEachYearContainer}
    >
      <Element
        style={{
          borderBottom: !isDynamicReport ? '1px solid #B5CEF8' : undefined,
        }}
        className={`dFlex justifyContentEnd ${classes.tabContainer}`}
      >
        {!isDynamicReport ? (
          <Tabs
            activeKey={year}
            items={tabs}
            tabListClassName={classes.tabs}
            getAppendStyleItem={getAppendStyleItemWithCustom()}
            isScrollContent={false}
            onChange={setYear}
          />
        ) : (
          <>
            {!isNoData && (
              <div className="fw600 pt1 w100">
                <Translate value="common.FISCAL_YEAR" />: {year}
              </div>
            )}
          </>
        )}
      </Element>
      {!data.length ? (
        getNoDataComponent(isDynamicReport)
      ) : (
        <>
          <div className={!isDynamicReport ? 'mt2' : 'mt1'}>
            <Element style={{ color: '#191D25' }} className={classes.title}>
              <Translate value="financialAnalysis.DUPOND" />
            </Element>
            <div className={`${classes.mt2} dFlex alignItemsCenter`}>
              <Translate value="financialAnalysis.ROE" />
              <Element
                className={`${classes.percentHeader} ml1`}
                style={{ color: '#FFFFFF', background: '#8EA492' }}
              >
                {format('RT0060')}
              </Element>
            </div>
          </div>
          <div className={classes.content}>
            {mapData.map((items, index) => {
              const totalWidthIcon = (items.length - 1) * WIDTH_ICON

              return (
                <div
                  style={{ width: index > 0 ? widthContainers[0] : '100%' }}
                  className="dFlex"
                  key={index}
                >
                  <div
                    style={{ width: index > 1 ? widthContainers[1] : '100%' }}
                    className="dFlex"
                  >
                    {items.map(({ value, percent, title, color }, subIndex) => {
                      if (!subIndex) {
                        widthContainers[
                          index
                        ] = `calc((100% - ${totalWidthIcon}px) * (${percent} / 100))`
                      }

                      return (
                        <Fragment key={subIndex}>
                          {!!subIndex && (
                            <Element
                              className="dFlex justifyContentCenter alignItemsEnd pb1"
                              style={{ width: WIDTH_ICON + 'px', color }}
                            >
                              <i className="icon-delete" />
                            </Element>
                          )}
                          <Element
                            style={{
                              background: '#F3F3F3',
                              width: `calc((100% - ${totalWidthIcon}px) * (${percent} / 100))`,
                            }}
                            className={classes.contentItem}
                          >
                            <div className="w100">
                              <TextEllipsis text={title} isI18n={false} />
                              <Element
                                className={`${classes.percent}`}
                                style={{ color: '#FFFFFF', background: color }}
                              >
                                {format(value)}
                              </Element>
                            </div>
                          </Element>
                        </Fragment>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default EachYear
